import { render } from "./Setting2.vue?vue&type=template&id=46eb0a10"
import script from "./Setting2.vue?vue&type=script&lang=js"
export * from "./Setting2.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__